export const IMAGE_SUPPORTED_FORMATS = [
  'image/png',
  'image/jpeg',
  'image/svg+xml',
  'image/webp',
];
